import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';
import { FileUploadCancellationRequest } from 'app/types/fileProcessingService';

export interface CancelEDFFileRequest {
  fileUploadId: string;
  cancellationRequest?: FileUploadCancellationRequest;
}

const useCancelEDFFile = (options?: UseMutationOptions<void, Error, CancelEDFFileRequest>) => {
  return useMutation<void, Error, CancelEDFFileRequest>({
    mutationFn: async ({ fileUploadId, cancellationRequest = {} }) => {
      return FileProcessingApiHandler.cancelFileUpload(
        fileUploadId,
        cancellationRequest as Record<string, unknown>
      );
    },
    ...options,
  });
};

export default useCancelEDFFile;
